<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title mb-15">
        <div class="row">
          <div class="col-md-6">
            <h4 class="text-bold">Fabric Order Deliveries</h4>
          </div>
          <div class="col-md-6 text-right">
            <toggle-button v-model="showOldDeliveries" @input="reload()" /> Show
            Old Deliveries
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="input-group transparent">
              <span class="input-group-addon">
                <i class="fa fa-search" aria-hidden="true"></i>
              </span>
              <input
                type="text"
                class="form-control search-delivery"
                @keyup.enter="searchDelivery()"
                v-model="searchTerm"
                placeholder="Search deliveries"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="grid-body">
        <div class="table-responsive">
          <vue-good-table
            styleClass="table table-bordered"
            :rows="rows"
            :totalRows="totalRecords"
            :search-options="{ enabled: false }"
            :pagination-options="{
              enabled: true,
              mode: 'pages',
            }"
            :columns="columns"
          >
            <template slot="table-column" slot-scope="props">
              <span v-if="props.column.label == 'Remaining Fabrics'">
                <span v-if="showOldDeliveries">Delivered Fabrics</span>
                <span v-else>Remaining Fabrics</span>
              </span>
              <span v-else-if="props.column.label == 'Date'">
                <span v-if="showOldDeliveries">Delivered Date</span>
                <span v-else>Order Creation Date</span>
              </span>
              <span v-else>
                {{ props.column.label }}
              </span>
            </template>

            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field === 'name'">
                <router-link
                  :to="{
                    name: 'fabric_suppliers_update',
                    params: { supplier_id: props.row.fabric_supplier_id },
                  }"
                >
                  {{ props.row.name }}
                </router-link>
              </span>
              <span v-else-if="props.column.field === 'created_at'">
                <span v-if="showOldDeliveries">{{
                  moment(props.row.delivery_date).format("DD MMM, YYYY")
                }}</span>
                <span v-else>{{
                  moment(props.row.order_creation_date).format("DD MMM, YYYY")
                }}</span>
              </span>
              <span v-else-if="props.column.field === 'left_amount'">
                {{ ezy.comma(props.row.leftAmount) }} m
              </span>
              <span v-else-if="props.column.field === 'menu'">
                <router-link
                  :to="{
                    path: `/fabric/order/${props.row.fabric_order_id}/delivery/view`,
                  }"
                  class="btn btn-primary"
                >
                  <i class="fa fa-eye" aria-hidden="true"></i>
                  View Delivery
                </router-link>

                <router-link
                  v-if="!isReadOnlyUser"
                  :to="{
                    path: `/fabric/order/${props.row.fabric_order_id}/delivery/create`,
                  }"
                  class="btn btn-success"
                >
                  Add Delivery
                </router-link>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TableHelper } from "@/pages/Tools/TableHelper.js";
import { VueGoodTable } from "vue-good-table";
export default {
  components: {
    VueGoodTable,
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.helper = new TableHelper({
      parent: this,
      endpoint: "/v2/fabrics/order/0/delivery",
      sort: {
        id: "desc",
        name: "asc",
      },
      clientSortOnly: ["fabric_ids"],
    });
  },
  data() {
    return {
      searchTerm: "",
      rows: [],
      columns: [
        {
          label: "Order Number",
          field: "order_reference",
          globalSearchDisabled: true,
        },
        { label: "Date", field: "created_at", globalSearchDisabled: true },
        { label: "Supplier", field: "name" },
        {
          label: "Remaining Fabrics",
          field: "fabric_ids",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "amount",
          field: "left_amounts",
          tdClass: "text-right",
          thClass: "text-right",
          globalSearchDisabled: true,
        },
        {
          label: "",
          field: "menu",
          tdClass: "text-right",
          globalSearchDisabled: true,
        },
      ],
      showOldDeliveries: false,
      helper: undefined,
      totalRecords: 0,
      isReadOnlyUser: false,
    };
  },
  methods: {
    /**
     * Reload the table when showOldDeliveries input is clicked
     */
    reload() {
      this.helper.page = 1;
      this.helper.reloadData();
    },

    /**
     * Append showOldDeliveries to the query parameters
     */
    getCustomListingParams() {
      return {
        showOldDeliveries: this.showOldDeliveries,
        search: this.searchTerm,
        filters: "fabric_suppliers.name",
      };
    },

    /**
     * This method sort the leftFabrics IDs, then concatenate them with a comma
     * @TODO Merge the list of remaining fabrics and the amount into one column, and put the amount in ()
     *  J4(10.31kg)
     */
    preProcessCollection(collection) {
      collection = collection.map((d) => {
        d["fabric_ids"] = d.leftFabrics
          .sort(function (a, b) {
            return a - b;
          })
          .join(", ");
        return d;
      });

      collection = collection.map((d) => {
        d["left_amounts"] = d.leftAmounts
          .sort(function (a, b) {
            return a.fabric_id - b.fabric_id;
          })
          .map((f) => { return f.left_amount })
          .join(", ");
        return d;
      });


      return collection;
    },
    searchDelivery() {
      this.reload();
    },
  },
};
</script>
